import { Editor, Node, Transforms } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export const insertNodes = (
    editor: Editor,
    props: Node | Node[],
    options?: WithQueryOptions<typeof Transforms.insertNodes, 2>
) => Transforms.insertNodes(editor, props, getQueryOptions(editor, options));
